import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.325 21.333H6v-.666h1.333V12H6v-1.333h2V6h-.667V4.667H12V6h-.667v4.667h2V4h-.667V2.667h6.667V4h-.666v6.667h2V6H20V4.667h4.666V6H24v4.667h2V12h-1.334v8.667H26v.666h5.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M9.667 7.333a1 1 0 0 1 1 1v2.334h-2V8.333a1 1 0 0 1 1-1M16 6.667c.736 0 1.333.597 1.333 1.333v2.667h-2.666V8c0-.736.597-1.333 1.333-1.333m6.334.666a1 1 0 0 1 1 1v2.334h-2V8.333a1 1 0 0 1 1-1M10 16c.736 0 1.333.597 1.333 1.333v2H8.666v-2A1.334 1.334 0 0 1 10 16m6-1.333a2 2 0 0 1 2 2v2.666h-4v-2.666a2 2 0 0 1 2-2M22 16c.736 0 1.333.597 1.333 1.333v2h-2.666v-2c0-.736.596-1.333 1.333-1.333",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16.442 20.237c.356-.433 1.36-.866 1.437-.893v-.57c-.15.051-1.491.856-1.72 1.126-.447-.333-1.697-.944-2.092-1.145l-.018.501c.337.18 1.372.601 1.736.98-.223.103-.364.289-.364.535v1.096l-1.153.73h-.321v.559h.321l1.481.937v3.485h-1.802v1.056h.572v-.53h.779v.53h.451v.351h-.451v.529h-.779v-.529h-.572v1.056h1.802v.704h.492V23.99l1.316-.833h.322v-.56h-.322l-.825-.522v-1.303c0-.375-.21-.424-.29-.534",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagGib = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagGib_default = SvgFlagGib;

export { FlagGib_default as default };
